/* Claude 22.10.2026: SE viser alltid NO-omtalene (NO-produktet slås opp først, SE-egne omtaler brukes bare når NO-produktet ikke har noen). Før ble NO bare brukt når SE-produktet hadde 0 egne omtaler, så 96 produkter viste noen få svenske i stedet for NO. Mellomlager v4. */
/* lipscore-cards-v6.js (Claude 15.10.2026): kopi av lipscore-cards-v5.js med ny oppførsel for produktomtalene (hele stjerneraden ruller til «Kundeomtaler»). Nytt filnavn så Shopifys CDN ikke sender en gammel versjon. */
/* lipscore-cards-v5.js (Claude 02.10.2026): utviklerens oppslag mot norske produkt-ID-er (temaet «Draft - Makeup Mekka SE»), med omstart av allerede tegnede widgets, + rettet vakt. Nytt filnavn så CDN-en ikke sender en gammel versjon. */
/*
 * Lipscore on product cards and the PDP rating block.
 *
 * Official widget markup stays in the Liquid. Lipscore paints those widgets
 * after onload — and often does not, on collection grids, Hello Retail
 * carousels, or the theme editor. This file:
 *   1. Re-runs lipscore.initWidgets() when new cards appear.
 *   2. Loads the official script if the Init app embed never arrived.
 *   3. Fetches ratings from the Lipscore API and draws stars when a widget
 *      stays empty, same approach as the beautyheaven theme.
 */
(function () {
  var SELECTOR = '[data-mm-lipscore]';
  var CACHE_PREFIX = 'mmLipscore:v4:';
  /* Swedish (and DK on the same shop) Shopify ids are not the ids Lipscore
     stored the reviews under. Those records use the Norwegian product id.
     makeupmekka.com/products/{handle}.js is the shared catalog lookup. */
  var CATALOG_ORIGIN = 'https://makeupmekka.com';
  var catalogIdByHandle = {};
  var catalogMissByHandle = {};
  var CACHE_TTL = 30 * 60 * 1000;
  var MAX_CONCURRENT = 6;

  var apiKeyLookupDone = false;
  var apiKey = null;
  var slotsByProduct = {};
  var resultsByProduct = {};
  var queue = [];
  var activeRequests = 0;
  var observer = null;
  var scriptInjected = false;

  function getApiKey() {
    if (apiKeyLookupDone) return apiKey;
    apiKeyLookupDone = true;

    var configured = window.mmLipscore && window.mmLipscore.apiKey;
    if (configured) {
      apiKey = String(configured).trim();
      if (apiKey) return apiKey;
    }

    var pattern = /apiKey["'\s:]+([A-Za-z0-9]{12,})/;
    var candidates = [];

    if (typeof window.lipscoreInit === 'function') {
      candidates.push(String(window.lipscoreInit));
    }
    if (window.lipscore && window.lipscore.apiKey) {
      apiKey = String(window.lipscore.apiKey);
      return apiKey;
    }

    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i++) {
      if (scripts[i].src) continue;
      var body = scripts[i].textContent;
      if (body && body.indexOf('apiKey') !== -1) candidates.push(body);
    }

    for (var j = 0; j < candidates.length; j++) {
      var match = candidates[j].match(pattern);
      if (match) {
        apiKey = match[1];
        break;
      }
    }

    return apiKey;
  }

  function getLocale() {
    return (window.mmLipscore && window.mmLipscore.locale) || 'no';
  }

  function initOfficialWidgets() {
    if (window.lipscore && typeof window.lipscore.initWidgets === 'function') {
      window.lipscore.initWidgets();
    }
  }

  function ensureOfficialScript() {
    if (window.lipscore || scriptInjected) {
      initOfficialWidgets();
      return;
    }

    if (document.querySelector('script[src*="lipscore-v1"]')) {
      initOfficialWidgets();
      return;
    }

    var key = getApiKey();
    if (!key) return;

    scriptInjected = true;
    if (typeof window.lipscoreInit !== 'function') {
      window.lipscoreInit = function () {
        lipscore.init({ apiKey: key });
        lipscore.initWidgets();
      };
    }

    var scr = document.createElement('script');
    scr.async = 1;
    scr.src = '//static.lipscore.com/assets/' + getLocale() + '/lipscore-v1.js';
    document.head.appendChild(scr);
  }

  function cacheRead(productId) {
    try {
      var raw = window.sessionStorage.getItem(CACHE_PREFIX + productId);
      if (!raw) return null;
      var entry = JSON.parse(raw);
      if (!entry || Date.now() - entry.time > CACHE_TTL) return null;
      return entry.data;
    } catch (error) {
      return null;
    }
  }

  function cacheWrite(productId, data) {
    try {
      window.sessionStorage.setItem(
        CACHE_PREFIX + productId,
        JSON.stringify({ time: Date.now(), data: data })
      );
    } catch (error) {
      /* Private mode or a full quota is not a reason to lose the stars. */
    }
  }

  function normalize(data) {
    if (!data) return null;

    var votes = Number(data.votes != null ? data.votes : data.total_votes);
    if (!votes || votes < 1) return null;

    var raw = parseFloat(data.lipscore != null ? data.lipscore : data.rating);
    if (!isFinite(raw)) return null;

    var score = raw / 2;
    if (score > 5) score = 5;
    if (score < 0) score = 0;

    return { score: score, votes: votes };
  }

  function isProductCardSlot(slot) {
    return !!(slot.closest && slot.closest('.product-card'));
  }

  function officialHasPainted(slot) {
    if (isProductCardSlot(slot)) return false;

    var node = slot.querySelector('#lipscore-rating');
    return !!(node && node.childNodes.length && node.offsetHeight > 2);
  }

  function paintHost(slot) {
    return slot.querySelector('[data-mm-lipscore-fallback]') || slot;
  }

  function paint(slot, rating) {
    if (officialHasPainted(slot)) return;

    var host = paintHost(slot);
    var percent = (rating.score / 5) * 100;
    var stars = document.createElement('span');
    stars.className = 'mm-lipscore__stars';
    stars.style.setProperty('--mm-lipscore-fill', percent.toFixed(1) + '%');

    var count = document.createElement('span');
    count.className = 'mm-lipscore__count';
    count.textContent = '(' + rating.votes + ')';

    host.textContent = '';
    host.appendChild(stars);
    host.appendChild(count);
    if (slot.hasAttribute('data-mm-lipscore-product-reviews')) {
      slot.setAttribute('role', 'button');
      slot.setAttribute('tabindex', '0');
      slot.setAttribute(
        'aria-label',
        rating.score.toFixed(1) + ' / 5 (' + rating.votes + ')'
      );
    } else {
      host.setAttribute('role', 'img');
      host.setAttribute(
        'aria-label',
        rating.score.toFixed(1) + ' / 5 (' + rating.votes + ')'
      );
    }
    host.hidden = false;
    host.removeAttribute('hidden');
    slot.classList.add('mm-lipscore--painted');
  }

  function applyToProduct(productId, rating) {
    resultsByProduct[productId] = rating;

    var slots = slotsByProduct[productId] || [];
    for (var i = 0; i < slots.length; i++) {
      if (rating) paint(slots[i], rating);
    }
    if (rating) slotsByProduct[productId] = [];
  }

  function drain() {
    while (activeRequests < MAX_CONCURRENT && queue.length) {
      request(queue.shift());
    }
  }

  function slotHandle(slot) {
    if (!slot) return '';
    var own = slot.getAttribute('data-product-handle');
    if (own) return own;
    var card = slot.closest && slot.closest('product-card');
    if (card && card.getAttribute('handle')) return card.getAttribute('handle');
    if (slot.closest && slot.closest('.product-card')) return '';
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function ratingUrl(key, lookupId, sku) {
    return (
      'https://wapi.lipscore.com/initial_data/products/show?api_key=' +
      encodeURIComponent(key) +
      '&internal_id=' +
      encodeURIComponent(lookupId) +
      '&sku=' +
      encodeURIComponent(sku || '') +
      '&widgets=r&translate_to_lang=' +
      encodeURIComponent(getLocale())
    );
  }

  function fetchRating(key, lookupId, sku) {
    return fetch(ratingUrl(key, lookupId, sku), { credentials: 'omit' }).then(function (response) {
      return response.ok ? response.json() : null;
    });
  }

  /* Point the product-page widgets at the id that actually has reviews.
     Card slots keep the local id; the script paints those itself. */
  function pointWidgetsAt(localId, catalogId) {
    if (!catalogId || String(catalogId) === String(localId)) return;
    var nodes = document.querySelectorAll('[data-ls-product-id="' + localId + '"]');
    var shouldInit = false;
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (isProductCardSlot(node)) continue;
      node.setAttribute('data-ls-product-id', String(catalogId));
      /* Claude 02.10.2026: Lipscore tegner ikke en allerede tegnet widget på nytt når ID-en endres. Widgets som
         er tegnet (stjernene og en aktivert omtaleliste) byttes derfor mot et rent element med samme id, klasse
         og data-felter, og Lipscore startes på nytt (reInitWidgets). Plassholdere som ennå ikke er aktivert, får
         bare ny ID og tegnes riktig når de aktiveres. */
      if (node.id === 'lipscore-rating' || node.id === 'lipscore-review-list') {
        var fresh = document.createElement(node.tagName);
        for (var j = 0; j < node.attributes.length; j++) {
          var a = node.attributes[j];
          if (a.name === 'id' || a.name === 'class' || a.name.indexOf('data-') === 0) fresh.setAttribute(a.name, a.value);
        }
        node.parentNode.replaceChild(fresh, node);
      }
      shouldInit = true;
    }
    if (!shouldInit) return;
    try {
      if (window.lipscore && typeof window.lipscore.reInitWidgets === 'function') window.lipscore.reInitWidgets();
      else initOfficialWidgets();
    } catch (error) {
      initOfficialWidgets();
    }
  }

  function catalogProductMatchesSku(product, sku) {
    var wanted = String(sku || '').trim();
    if (!wanted) return true;
    var variants = (product && product.variants) || [];
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].sku || '').trim() === wanted) return true;
    }
    return false;
  }

  function resolveCatalogProductId(handle, sku) {
    if (!handle) return Promise.resolve(null);
    if (catalogIdByHandle[handle]) return Promise.resolve(catalogIdByHandle[handle]);
    if (catalogMissByHandle[handle]) return Promise.resolve(null);

    return fetch(CATALOG_ORIGIN + '/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'omit',
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (product) {
        if (!product || !product.id || !catalogProductMatchesSku(product, sku)) {
          catalogMissByHandle[handle] = true;
          return null;
        }
        var id = String(product.id);
        catalogIdByHandle[handle] = id;
        return id;
      })
      .catch(function () {
        return null;
      });
  }

  function storeRating(job, data, rating) {
    if (rating && job.lookupId && data) {
      data._mmCatalogId = job.lookupId;
      pointWidgetsAt(job.productId, job.lookupId);
    }
    if (data && (data.lipscore != null || data.votes != null || data.rating != null)) {
      cacheWrite(job.productId, data);
    }
    applyToProduct(job.productId, rating);
  }

  function request(job) {
    var key = getApiKey();
    if (!key) return;

    activeRequests++;

    /* NO-produktet (katalogen) først: SE skal vise de samme omtalene som NO. Har NO-produktet ingen
       omtaler, eller finnes det ikke i NO, brukes SE-produktets egne. */
    resolveCatalogProductId(job.handle, job.sku)
      .then(function (catalogId) {
        job.catalogTried = true;
        if (catalogId && catalogId !== String(job.productId)) {
          job.lookupId = catalogId;
          return fetchRating(key, catalogId, job.sku).then(function (catalogData) {
            var catalogRating = normalize(catalogData);
            if (catalogRating) {
              storeRating(job, catalogData, catalogRating);
              return;
            }
            job.lookupId = null;
            return fetchRating(key, job.productId, job.sku).then(function (data) {
              storeRating(job, data, normalize(data));
            });
          });
        }
        return fetchRating(key, job.productId, job.sku).then(function (data) {
          storeRating(job, data, normalize(data));
        });
      })
      .catch(function () {
        /* A failed rating lookup must never break the card. */
      })
      .then(function () {
        activeRequests--;
        drain();
      });
  }

  function load(slot) {
    var productId = slot.getAttribute('data-ls-product-id');
    if (!productId) return;

    /* Claude 22.10.2026: en allerede tegnet Lipscore-widget (produktsiden) hoppes ikke lenger over – den kan
       være tegnet med SE-produktets egne omtaler og må byttes til NO-produktet (pointWidgetsAt). paint() lar
       fortsatt en tegnet widget være i fred. */

    if (resultsByProduct[productId] !== undefined) {
      if (resultsByProduct[productId]) paint(slot, resultsByProduct[productId]);
      return;
    }

    var alreadyQueued = !!slotsByProduct[productId];
    if (!alreadyQueued) slotsByProduct[productId] = [];
    slotsByProduct[productId].push(slot);
    if (alreadyQueued) return;

    var cachedRaw = cacheRead(productId);
    if (cachedRaw && (cachedRaw.lipscore != null || cachedRaw.votes != null || cachedRaw.rating != null)) {
      if (cachedRaw._mmCatalogId) pointWidgetsAt(productId, cachedRaw._mmCatalogId);
      applyToProduct(productId, normalize(cachedRaw));
      return;
    }

    queue.push({
      productId: productId,
      sku: slot.getAttribute('data-ls-sku'),
      handle: slotHandle(slot),
    });
    drain();
  }

  function observationTarget(slot) {
    return (
      slot.closest('.product-card') ||
      slot.closest('.product-info__block-item') ||
      slot.parentElement ||
      slot
    );
  }

  function getObserver() {
    if (observer || typeof IntersectionObserver === 'undefined') return observer;

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);

          var pending = entry.target.mmLipscoreSlots || [];
          entry.target.mmLipscoreSlots = null;
          for (var i = 0; i < pending.length; i++) load(pending[i]);
        });
      },
      { rootMargin: '300px 0px' }
    );

    return observer;
  }

  function scan() {
    initOfficialWidgets();
    if (!getApiKey()) return;

    var slots = document.querySelectorAll(SELECTOR + ':not([data-mm-lipscore-bound])');
    if (!slots.length) return;

    var watcher = getObserver();

    for (var i = 0; i < slots.length; i++) {
      slots[i].setAttribute('data-mm-lipscore-bound', '');

      if (!watcher) {
        load(slots[i]);
        continue;
      }

      var target = observationTarget(slots[i]);
      if (target.mmLipscoreSlots) {
        target.mmLipscoreSlots.push(slots[i]);
      } else {
        target.mmLipscoreSlots = [slots[i]];
        watcher.observe(target);
      }
    }
  }

  window.mmLipscoreScan = scan;

  function scanWithRetry(attemptsLeft) {
    apiKeyLookupDone = false;
    ensureOfficialScript();
    scan();
    if ((getApiKey() && window.lipscore) || attemptsLeft <= 0) return;
    setTimeout(function () {
      scanWithRetry(attemptsLeft - 1);
    }, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scanWithRetry(8);
    });
  } else {
    scanWithRetry(8);
  }

  window.addEventListener('load', function () {
    scanWithRetry(5);
  });

  document.addEventListener('facet:update', function () {
    setTimeout(scan, 250);
  });

  document.addEventListener('shopify:section:load', scan);

  /*
   * Footer store badge. Official service widgets are iframes and cannot match
   * the footer type size, so the score is fetched and drawn in the theme.
   */
  function serviceNormalize(data, depth) {
    if (!data || typeof data !== 'object' || depth > 5) return null;
    if (depth == null) depth = 0;

    var votes = Number(
      data.votes != null
        ? data.votes
        : data.total_votes != null
          ? data.total_votes
          : data.review_count
    );
    var raw = parseFloat(
      data.lipscore != null ? data.lipscore : data.rating != null ? data.rating : data.ls
    );

    if (votes >= 1 && isFinite(raw)) {
      var score = raw > 5 ? raw / 2 : raw;
      if (score > 5) score = 5;
      if (score < 0) score = 0;
      return { score: score, votes: votes };
    }

    if (Array.isArray(data)) {
      for (var i = 0; i < data.length; i++) {
        var fromList = serviceNormalize(data[i], depth + 1);
        if (fromList) return fromList;
      }
      return null;
    }

    for (var key in data) {
      if (!Object.prototype.hasOwnProperty.call(data, key)) continue;
      if (data[key] && typeof data[key] === 'object') {
        var nested = serviceNormalize(data[key], depth + 1);
        if (nested) return nested;
      }
    }

    return null;
  }

  function paintService(badge, rating) {
    var scoreEl = badge.querySelector('[data-mm-lipscore-score]');
    var starsEl = badge.querySelector('[data-mm-lipscore-stars]');
    var captionEl = badge.querySelector('[data-mm-lipscore-caption]');
    var template = badge.getAttribute('data-mm-caption') || '';

    if (scoreEl) scoreEl.textContent = rating.score.toFixed(1);
    if (starsEl) {
      starsEl.className = 'mm-lipscore__stars';
      starsEl.style.setProperty('--mm-lipscore-fill', ((rating.score / 5) * 100).toFixed(1) + '%');
    }
    if (captionEl) {
      captionEl.textContent = template.replace('___', String(rating.votes));
    }

    badge.hidden = false;
    badge.removeAttribute('hidden');
    badge.setAttribute(
      'aria-label',
      rating.score.toFixed(1) + ' / 5 (' + rating.votes + ')'
    );
    hideServiceFallback();
  }

  function showServiceFallback() {
    var fallback = document.querySelector('[data-mm-lipscore-service-fallback]');
    if (fallback) fallback.removeAttribute('hidden');
    initOfficialWidgets();
  }

  function hideServiceFallback() {
    var fallback = document.querySelector('[data-mm-lipscore-service-fallback]');
    if (fallback) fallback.setAttribute('hidden', '');
  }

  function paintAllServiceBadges(rating) {
    var badges = document.querySelectorAll('[data-mm-lipscore-service]');
    for (var i = 0; i < badges.length; i++) paintService(badges[i], rating);
    hideServiceFallback();
    initOfficialWidgets();
  }

  function loadServiceBadge() {
    var badges = document.querySelectorAll('[data-mm-lipscore-service]');
    if (!badges.length) return;

    var key = getApiKey();
    if (!key) {
      showServiceFallback();
      return;
    }

    var cached = serviceNormalize(cacheRead('service'));
    if (cached) {
      paintAllServiceBadges(cached);
      return;
    }

    var locale = getLocale();
    var urls = [
      'https://wapi.lipscore.com/initial_data/products/show?api_key=' +
        encodeURIComponent(key) +
        '&internal_id=service_review&sku=&widgets=r&translate_to_lang=' +
        encodeURIComponent(locale),
      'https://wapi.lipscore.com/initial_data/settings/show?api_key=' +
        encodeURIComponent(key) +
        '&lang=' +
        encodeURIComponent(locale),
      'https://wapi.lipscore.com/initial_data/companies/show?api_key=' +
        encodeURIComponent(key) +
        '&translate_to_lang=' +
        encodeURIComponent(locale),
    ];

    function tryUrl(index) {
      if (index >= urls.length) {
        showServiceFallback();
        return;
      }
      fetch(urls[index], { credentials: 'omit' })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (data) {
          var rating = serviceNormalize(data);
          if (rating) {
            cacheWrite('service', data);
            paintAllServiceBadges(rating);
            return;
          }
          tryUrl(index + 1);
        })
        .catch(function () {
          tryUrl(index + 1);
        });
    }

    tryUrl(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadServiceBadge);
  } else {
    loadServiceBadge();
  }

  function serviceBadgeHost() {
    var selectors = [
      '[data-mm-lipscore-service-source] .lipscore-service-review-badge-small-long',
      '[data-mm-lipscore-service-source] .lipscore-service-review-modal-toggle',
      '.lipscore-service-review-badge-small-long.lipscore-service-review-modal-toggle',
      '[data-mm-lipscore-service-fallback] .lipscore-service-review-badge-small-long',
      '.lipscore-service-review-badge-starred:not(.lipscore-service-review-badge-embedded)',
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function showServiceReviewModal(host) {
    var ls = window.lipscore;
    if (ls && ls.$g && typeof ls.$g.show === 'function') {
      ls.$g.show(host);
      return true;
    }
    if (typeof host.click === 'function') {
      host.click();
      return true;
    }
    return false;
  }

  var openLockUntil = 0;

  function openServiceReviews() {
    var now = Date.now();
    if (now < openLockUntil) return;
    openLockUntil = now + 600;

    ensureOfficialScript();
    initOfficialWidgets();

    function hostIsReady(host) {
      return !!(
        host.classList.contains('lipscore-service-review-modal-toggle') ||
        host.getAttribute('data-ls-lipscore-product-id')
      );
    }

    function attempt(remaining) {
      var host = serviceBadgeHost();
      if (host && hostIsReady(host) && showServiceReviewModal(host)) return;
      if (remaining <= 0) {
        if (host) showServiceReviewModal(host);
        return;
      }
      window.setTimeout(function () {
        initOfficialWidgets();
        attempt(remaining - 1);
      }, 250);
    }

    attempt(8);
  }

  window.mmOpenLipscoreServiceReviews = openServiceReviews;
  window.mmLoadLipscoreServiceBadge = loadServiceBadge;

  function reviewsTitle() {
    return (window.mmLipscore && window.mmLipscore.reviewsTitle) || 'Reviews';
  }

  function productReviewAttrSource() {
    return (
      document.getElementById('lipscore-review-list') ||
      document.getElementById('lipscore-rating') ||
      document.querySelector('[data-mm-lipscore-product-reviews]')
    );
  }

  function productReviewListHtml() {
    var source = productReviewAttrSource();
    if (!source) return '';
    var parts = [
      'class="lipscore-review-list mm-lipscore-review-list"',
      'id="lipscore-review-list-modal"',
      'data-ls-page-size="5"',
    ];
    for (var i = 0; i < source.attributes.length; i++) {
      var attr = source.attributes[i];
      if (attr.name.indexOf('data-ls-') !== 0) continue;
      if (attr.name === 'data-ls-connected-review-list-id') continue;
      if (attr.name === 'data-ls-page-size') continue;
      parts.push(attr.name + '="' + String(attr.value).replace(/"/g, '&quot;') + '"');
    }
    return '<div ' + parts.join(' ') + '></div>';
  }

  function hideLipscoreShellModal() {
    var ls = window.lipscore;
    if (ls && ls.uc && typeof ls.uc.get === 'function') {
      var shell = ls.uc.get();
      if (shell && shell.Ib && typeof shell.hide === 'function') {
        try {
          shell.hide();
        } catch (error) {}
      }
    }
    var leftover = document.getElementById('lipscore-modal');
    if (leftover) leftover.style.display = 'none';
    var backdrops = document.querySelectorAll('.lipscore-modal-backdrop');
    for (var i = 0; i < backdrops.length; i++) {
      if (backdrops[i].parentNode) backdrops[i].parentNode.removeChild(backdrops[i]);
    }
    document.body.classList.remove('lipscore-modal-open');
  }

  function closeThemeProductModal() {
    var modal = document.querySelector('[data-mm-lipscore-product-modal]');
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.body.classList.remove('mm-lipscore-product-modal-open');
  }

  function clonePageReviewList() {
    var existing = document.getElementById('lipscore-review-list');
    if (!existing || !existing.innerHTML || existing.innerHTML.trim().length < 40) return '';
    var clone = existing.cloneNode(true);
    clone.id = 'lipscore-review-list-modal';
    var nodes = clone.querySelectorAll('[id]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].id = nodes[i].id + '-modal';
    }
    return clone.outerHTML;
  }

  function fillProductModalBody(body) {
    var cloned = clonePageReviewList();
    if (cloned) {
      body.innerHTML = cloned;
      return;
    }
    body.innerHTML = productReviewListHtml();
    ensureOfficialScript();
    initOfficialWidgets();
    if (window.lipscore && typeof window.lipscore.reInitWidgets === 'function') {
      window.lipscore.reInitWidgets();
    }
  }

  function openThemeProductModal() {
    hideLipscoreShellModal();

    var modal = document.querySelector('[data-mm-lipscore-product-modal]');
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'mm-lipscore-product-modal';
      modal.setAttribute('data-mm-lipscore-product-modal', '');
      modal.innerHTML =
        '<div class="mm-lipscore-product-modal__backdrop" data-mm-lipscore-product-modal-close></div>' +
        '<div class="mm-lipscore-product-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="mm-lipscore-product-modal-title">' +
        '<div class="mm-lipscore-product-modal__header">' +
        '<h2 class="mm-lipscore-product-modal__title" id="mm-lipscore-product-modal-title"></h2>' +
        '<button type="button" class="mm-lipscore-product-modal__close" data-mm-lipscore-product-modal-close aria-label="Close">&times;</button>' +
        '</div>' +
        '<div class="mm-lipscore-product-modal__body" data-mm-lipscore-product-modal-body></div>' +
        '</div>';
      document.body.appendChild(modal);
    }

    var titleEl = modal.querySelector('#mm-lipscore-product-modal-title');
    var body = modal.querySelector('[data-mm-lipscore-product-modal-body]');
    if (titleEl) titleEl.textContent = reviewsTitle();
    if (body) fillProductModalBody(body);
    modal.removeAttribute('hidden');
    document.body.classList.add('mm-lipscore-product-modal-open');
    return true;
  }

  var productOpenLockUntil = 0;

  function openProductReviews() {
    var now = Date.now();
    if (now < productOpenLockUntil) return;
    productOpenLockUntil = now + 600;
    var target = document.querySelector('.shopify-section[id*="__lipscore_reviews"]') ||
      document.getElementById('lipscore-review-list');
    if (!target) { openThemeProductModal(); return; }
    var header = document.querySelector('.shopify-section--header') || document.querySelector('header');
    var offset = (header ? header.getBoundingClientRect().height : 0) + 16;
    var y = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  window.mmOpenLipscoreProductReviews = openProductReviews;

  function isProductReviewTrigger(el) {
    /* Claude 15.10.2026: hele stjeneraden ved produkttittelen (stjerner, snitt og «Omtaler (N)») ruller ned til
       omtalelisten «Kundeomtaler» på siden – Lipscores egen standard når listen finnes på siden. Den gamle
       omtaleboksen (kopi av listen) er ikke lenger i bruk: i kopien virket ikke sider, sortering og filtre. */
    return el && el.closest ? el.closest('[data-mm-lipscore-native]') : null;
    if (!el || !el.closest) return null;
    if (el.closest('.lipscore-rating-slider, .lipscore-rating-star-wrapper, [data-mm-lipscore-product-modal]')) {
      return null;
    }
    return (
      el.closest('[data-mm-lipscore-product-reviews]') ||
      el.closest('.lipscore-rating-review-link')
    );
  }

  document.addEventListener(
    'click',
    function (event) {
      if (event.target.closest && event.target.closest('[data-mm-lipscore-product-modal-close]')) {
        event.preventDefault();
        closeThemeProductModal();
        return;
      }

      var trigger = isProductReviewTrigger(event.target);
      if (!trigger) return;
      event.preventDefault();
      event.stopPropagation();
      openProductReviews();
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeThemeProductModal();
    var target = event.target;
    if (!target || !target.closest) return;
    if (target.closest('[data-mm-lipscore-product-reviews]') && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      openProductReviews();
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('[data-mm-lipscore-product-reviews]')) return;
    var trigger = event.target.closest('[data-mm-lipscore-service], .header__top-bar-lipscore-wrap');
    if (!trigger && event.clientX != null) {
      var hit = document.elementFromPoint(event.clientX, event.clientY);
      trigger = hit && hit.closest('[data-mm-lipscore-service], .header__top-bar-lipscore-wrap');
    }
    if (!trigger) return;
    event.preventDefault();
    openServiceReviews();
  });

  window.addEventListener('load', loadServiceBadge);
  document.addEventListener('shopify:section:load', loadServiceBadge);
})();

/*
  ====================================================================================================
  ROBUSTHET FOR PRODUKTOMTALER (Claude 30.09.2026)
  ====================================================================================================
  Problem: av og til (ofte ved første besøk på et produkt) ble anmeldelseslisten mellom sliderne og vinduet
  fra stjernene stående tomme; en oppdatering av siden løste det alltid.
  Løsning (gjør ingenting når alt virker):
    - Listen (#lipscore-review-list): er den tom ca. 3 s etter at den kommer i syne, erstattes den med et nytt,
      rent element med de samme data-ls-*-feltene og Lipscore bes initialisere widgetene på nytt
      (lipscore.reInitWidgets) – samme som en oppdatering gjør. Inntil 2 forsøk. Lykkes det ikke, skjules
      seksjonen (klassen mm-ls-empty); den vises igjen hvis omtalene kommer senere.
    - Vinduet fra stjernene ([data-mm-lipscore-product-modal]): viser «Laster omtaler …» og gjør det samme;
      lykkes det ikke, vises en kort beskjed i stedet for et blankt vindu.
*/
(function () {
  if (window.__mmLipscoreWatchdog) return;
  window.__mmLipscoreWatchdog = true;

  var lang = (document.documentElement.lang || 'nb').slice(0, 2).toLowerCase();
  var TEXT = {
    nb: { loading: 'Laster omtaler …', failed: 'Omtalene kunne ikke lastes akkurat nå. Prøv å laste siden på nytt.' },
    sv: { loading: 'Laddar omdömen …', failed: 'Omdömena kunde inte laddas just nu. Försök att ladda om sidan.' },
    da: { loading: 'Indlæser anmeldelser …', failed: 'Anmeldelserne kunne ikke indlæses lige nu. Prøv at genindlæse siden.' },
  };
  var T = TEXT[lang] || (lang === 'no' || lang === 'nn' ? TEXT.nb : TEXT.nb);
  var RETRY_MS = 3000;
  var MAX_TRIES = 2;

  var style = document.createElement('style');
  style.textContent =
    '.mm-ls-empty{display:none!important}' +
    '.mm-ls-status{margin:0;padding:16px 0;font-size:14px;opacity:.75;text-align:center}';
  document.head.appendChild(style);

  /* Fylt = synlig tekst, ikke bare HTML: Lipscore kan legge inn et tomt skjelett (rammer uten omtaler) og bli
     stående der – det skal regnes som tomt (rettet 01.10.2026). */
  function filled(el) {
    return !!(el && (el.innerText || '').trim().length > 40);
  }

  function reinit() {
    try {
      if (window.lipscore && typeof window.lipscore.reInitWidgets === 'function') window.lipscore.reInitWidgets();
    } catch (error) {}
  }

  /* Nytt, rent element med samme id, klasse og data-ls-*-felter (uten det Lipscore har lagt til). */
  function freshCopy(el) {
    var fresh = document.createElement(el.tagName);
    for (var i = 0; i < el.attributes.length; i++) {
      var a = el.attributes[i];
      if (a.name === 'id' || a.name === 'class' || a.name.indexOf('data-ls-') === 0 || a.name.indexOf('data-mm-') === 0) {
        fresh.setAttribute(a.name, a.value);
      }
    }
    el.parentNode.replaceChild(fresh, el);
    return fresh;
  }

  /* ---------- Listen mellom sliderne ---------- */
  function watchPageList() {
    var list = document.getElementById('lipscore-review-list');
    if (!list) {
      // Listen er fortsatt en plassholder (mm-lipscore-lazy.js aktiverer den når den nærmer seg) – vent på den.
      if (!document.querySelector('[data-mm-lipscore-lazy]')) return;
      var waited = 0;
      var poll = window.setInterval(function () {
        waited += 1000;
        if (document.getElementById('lipscore-review-list')) { window.clearInterval(poll); watchPageList(); }
        else if (waited > 120000) window.clearInterval(poll);
      }, 1000);
      return;
    }
    var section = list.closest('.shopify-section') || list.parentElement;
    var tries = 0;
    var started = false;

    function check() {
      list = document.getElementById('lipscore-review-list');
      if (!list) return;
      if (filled(list)) {
        if (section) section.classList.remove('mm-ls-empty');
        return;
      }
      if (tries < MAX_TRIES) {
        tries++;
        list = freshCopy(list);
        observe(list);
        reinit();
        window.setTimeout(check, RETRY_MS);
      } else if (section) {
        section.classList.add('mm-ls-empty');
      }
    }

    function observe(el) {
      if (!('MutationObserver' in window)) return;
      new MutationObserver(function () {
        if (filled(el) && section) section.classList.remove('mm-ls-empty');
      }).observe(el, { childList: true, subtree: true });
    }

    function start() {
      if (started) return;
      started = true;
      window.setTimeout(check, RETRY_MS);
    }

    observe(list);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            io.disconnect();
            start();
          }
        }
      }, { rootMargin: '300px 0px' });
      io.observe(list);
    } else {
      start();
    }
  }

  /* ---------- Vinduet fra stjernene ---------- */
  function watchModal() {
    var modal = document.querySelector('[data-mm-lipscore-product-modal]');
    if (!modal || modal.hasAttribute('hidden') || modal.__mmWatched) return;
    var body = modal.querySelector('[data-mm-lipscore-product-modal-body]');
    if (!body) return;
    modal.__mmWatched = true;
    var tries = 0;

    function widget() {
      return body.querySelector('.lipscore-review-list, [id^="lipscore-review-list"]');
    }
    function status(text) {
      var s = body.querySelector('.mm-ls-status');
      if (!text) { if (s) s.remove(); return; }
      if (!s) { s = document.createElement('p'); s.className = 'mm-ls-status'; body.insertBefore(s, body.firstChild); }
      s.textContent = text;
    }
    function check() {
      if (modal.hasAttribute('hidden')) { modal.__mmWatched = false; return; }
      var w = widget();
      if (filled(w)) { status(null); modal.__mmWatched = false; return; }
      if (tries < MAX_TRIES && w) {
        tries++;
        status(T.loading);
        freshCopy(w);
        reinit();
        window.setTimeout(check, RETRY_MS);
      } else {
        status(filled(w) ? null : T.failed);
        modal.__mmWatched = false;
      }
    }

    if (!filled(widget())) status(T.loading);
    window.setTimeout(check, 1500);
  }

  document.addEventListener('click', function () { window.setTimeout(watchModal, 100); }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchPageList, { once: true });
  else watchPageList();
})();
